import React from 'react';
import { ParallaxSection } from './ParallaxSection';
export function StatsSection() {
  return <section className="relative h-[1024px] px-4 flex items-center justify-center overflow-hidden" data-id="element-108">
      <div className="max-w-7xl mx-auto w-full" data-id="element-109">
        <ParallaxSection speed={0.2} data-id="element-110">
          <div className="space-y-6 max-w-4xl mx-auto" data-id="element-111">
            <h2 className="text-4xl md:text-6xl font-bold leading-tight max-w-[280px] md:max-w-[700px]" data-id="element-112">
              The biospecimen market is broken.
            </h2>
            <p className="text-xl md:text-2xl text-white/80 leading-relaxed max-w-[280px] md:max-w-[740px]" data-id="element-113">
              Manual workflows collect patient samples, but they are fragmented,
              slow, and costly.
            </p>
          </div>
        </ParallaxSection>
      </div>
    </section>;
}